const statuses = [
    {'value': 'dhl', 'label': 'DHL', 'variation': 'negative'},
    {'value': 'usps', 'label': 'USPS', 'variation': 'positive'},
    {'value': 'ups', 'label': 'UPS', 'variation': 'positive'},
    {'value': 'multrans', 'label': 'Multrans', 'variation': 'positive'},
]

export default statuses
